import { FunctionComponent } from "react";

export const NotFoundPage: FunctionComponent = () => {
    return (
        <h1>Page not found.</h1>
    );
}